import React from 'react';
import Link from 'next/link';
import { useTranslations, useLocale } from 'next-intl';
import { useRouter } from 'next/router';

import Copy from '@components/atoms/copy/copy';
import Pagination from '@components/organisms/pagination/pagination';
import ArrowLeft from '@components/icons/arrowLeft.svg';
import ArchiveBackgroundIcon from '@components/icons/archive-background/archiveBackground';

import StyledArchiveHeader from './archive-header.style';

const ArchiveHeader = () => {
  const locale = useLocale();
  const t = useTranslations();
  const router = useRouter();
  const filterParams = new URLSearchParams(router.query).toString();
  const hasArchiveState = router.query.archiveState;

  const hasPagination = Object.keys(router.query).reduce((result, key) => {
    if (key.startsWith('PaginationLink')) {
      result.push(router.query[key]);
    }
    return result;
  }, []);

  return (
    <StyledArchiveHeader>
      <div className="archive-header__background">
        <ArchiveBackgroundIcon />
      </div>
      <Link
        href={{
          pathname: '/archive',
          query: { slug: 'index', lang: locale }
        }}
        as={`/${locale}/${locale === 'en' ? 'archive' : 'archiv'}/?${filterParams}`}
        className="archive-header__link"
      >
        <ArrowLeft />
        <Copy tag="span" thick>
          {t(hasArchiveState ? 'archive.detailPageBackLink' : 'archive.detailPageLink')}
        </Copy>
      </Link>
      {hasPagination.length > 1 && (
        <Pagination
          archiveListUrls={hasPagination}
          noPadding
          align="left"
          pageType="archive"
          totalPages={parseInt(hasPagination.length, 10)}
          currentPage={router.query.page ? parseInt(router.query.page, 10) : 1}
        />
      )}
    </StyledArchiveHeader>
  );
};

export default ArchiveHeader;
